import { SpotlightsApiResponse } from '../types/spotlights';

const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || 'https://bagr.iprosystems.com/api';
const API_KEY = import.meta.env.VITE_API_KEY;
const SITE_ID = import.meta.env.VITE_SITE_ID || 'marketplacedev';

/**
 * Fetches spotlights from the API
 */
export async function fetchSpotlights(): Promise<SpotlightsApiResponse> {
  const url = new URL(`${API_BASE_URL}/spotlights`);
  url.searchParams.append('populate', '*');
  url.searchParams.append('filters[site][SiteID][$eq]', SITE_ID);

  const headers: HeadersInit = {
    'Content-Type': 'application/json',
  };

  // Add API key to headers if provided
  if (API_KEY) {
    headers['Authorization'] = `Bearer ${API_KEY}`;
  }

  const response = await fetch(url.toString(), {
    method: 'GET',
    headers,
  });

  if (!response.ok) {
    throw new Error(`Failed to fetch spotlights: ${response.status} ${response.statusText}`);
  }

  return response.json();
}
